import axios from 'axios';
import store from '../store';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

let token = '';

export default {
  getSummary() {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/summary', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getQueueDepth(lookback: string) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/queue-depth', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lookback },
    });
  },
  getReplicas(lookback: string) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/replicas', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lookback },
    });
  },
  getSullyReplicas(lookback: string) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/sully-replicas', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lookback },
    });
  },
  getRawStorageQueueDepth(lookback: string) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/rawstorage-queue-depth', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lookback },
    });
  },
  getRawStorageReplicas(lookback: string) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/rawstorage-replicas', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lookback },
    });
  },
  getActivePigRuns(lookback: string) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/active-pigruns', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lookback },
    });
  },
  getSullyJobs(lookback: string, metric: string) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/sully-jobs', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lookback, metric },
    });
  },
  getSqlMetrics(lookback: string, metric: string) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/sql', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lookback, metric },
    });
  },
  getServices() {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/services', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getLogs(serviceName: string, count: number) {
    token = store.getters.token;
    return apiClient.get('/admin/metrics/logs', {
      headers: { Authorization: `Bearer ${token}` },
      params: { serviceName, count },
    });
  },
};
